function getProject (projectId) {
  if (!this.projects) return
  // if (!projectId) return
  const project = this.projects[projectId]
  if (!project) return
  // if (project.hasOwnProperty('delete') && project.delete) return
  return project
}

export default getProject